import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import CustomerHome from "@/pages/CustomerHome";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import AdminGate from "@/pages/AdminGate";
import AdminLayout from "@/pages/AdminLayout";
import AdminOrders from "@/pages/AdminOrders";
import AdminProducts from "@/pages/AdminProducts";
import AdminCategories from "@/pages/AdminCategories";
import AdminDepartments from "@/pages/AdminDepartments";
import AdminSettings from "@/pages/AdminSettings";
import AdminPromos from "@/pages/AdminPromos";
import AdminBulkImages from "@/pages/AdminBulkImages";
import AdminUsers from "@/pages/AdminUsers";
import DepartmentHome from "@/pages/DepartmentHome";
import { SettingsProvider } from "@/context/SettingsContext";
import "@/App.css";

function App() {
    // Register PWA service worker (production only; dev mode uses HMR)
    React.useEffect(() => {
        if (process.env.NODE_ENV !== "production") {
            // In dev, proactively unregister any previously registered SW and clear caches
            if ("serviceWorker" in navigator) {
                navigator.serviceWorker.getRegistrations().then((regs) => {
                    regs.forEach((r) => r.unregister());
                }).catch(() => {});
                if (typeof caches !== "undefined") {
                    caches.keys().then((keys) => {
                        keys.forEach((k) => caches.delete(k));
                    }).catch(() => {});
                }
            }
            return;
        }
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker
                .register("/service-worker.js")
                .catch(() => {});
        }
    }, []);

    return (
        <div className="App">
            <AdminAuthProvider>
                <SettingsProvider>
                <CartProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<DepartmentHome />} />
                            <Route path="/shop/:department" element={<CustomerHome />} />
                            <Route path="/product/:id" element={<ProductDetail />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/order/:id" element={<OrderSuccess />} />
                            <Route path="/admin" element={<AdminGate />}>
                                <Route element={<AdminLayout />}>
                                    <Route index element={<AdminOrders />} />
                                    <Route path="products" element={<AdminProducts />} />
                                    <Route path="categories" element={<AdminCategories />} />
                                    <Route path="departments" element={<AdminDepartments />} />
                                    <Route path="promos" element={<AdminPromos />} />
                                    <Route path="bulk-images" element={<AdminBulkImages />} />
                                    <Route path="users" element={<AdminUsers />} />
                                    <Route path="settings" element={<AdminSettings />} />
                                </Route>
                            </Route>
                        </Routes>
                    </BrowserRouter>
                    <Toaster
                        position="top-center"
                        toastOptions={{
                            style: {
                                fontFamily: "Outfit, sans-serif",
                                borderRadius: "1rem",
                            },
                        }}
                    />
                </CartProvider>
                </SettingsProvider>
            </AdminAuthProvider>
        </div>
    );
}

export default App;
